import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import NagusiBackNav from '../common/NagusiBackNav';
import SupporterClubCard from './SupporterClubCard';
import { loadLeaflet } from '../common/lazyAssetLoader';
const SHOW_BLOOD_DONATION = false; // Cambiar a true para alternar al llamamiento de donación de sangre

export default class SupporterClubsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--supporterClubs';
    this.searchQuery = '';
    this.loading = false;
    this.leafletReady = Boolean(typeof window !== 'undefined' && window.L);
    loadLeaflet().then(() => {
      this.leafletReady = true;
      m.redraw();
      setTimeout(() => {
        const dom = this.element || vnode && vnode.dom || document;
        this.initMap({
          dom
        });
      }, 50);
    }).catch(err => {
      console.error('Error cargando Leaflet:', err);
    });
    const clubs = app.store.all('supporter-clubs').filter(c => c.isActive());
    if (clubs.length === 0) {
      this.loading = true;
      app.store.find('supporter-clubs').then(() => {
        this.loading = false;
        m.redraw();
        if (this.leafletReady) {
          setTimeout(() => {
            const dom = this.element || vnode && vnode.dom || document;
            this.initMap({
              dom
            });
          }, 50);
        }
      }).catch(() => {
        this.loading = false;
        m.redraw();
      });
    }
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (!this.loading && this.leafletReady) {
      this.initMap(vnode);
    }
  }
  initMap(vnode) {
    if (typeof window === 'undefined' || !window.L) return;
    const L = window.L;
    const clubs = app.store.all('supporter-clubs').filter(c => c.isActive() && c.latitude() && c.longitude());
    if (clubs.length === 0) return;
    const rootDom = vnode && vnode.dom ? vnode.dom : this.element || document;
    const mapElement = rootDom.querySelector ? rootDom.querySelector('#supporter-clubs-map') : document.querySelector('#supporter-clubs-map');
    if (!mapElement) return;

    // Limpiar el contenedor si ya tiene un mapa (evitar duplicados)
    if (this.map) {
      this.map.remove();
    }
    this.map = L.map(mapElement).setView([43.2630, -2.9350], 7); // Centro en Euskadi/Bilbao

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20
    }).addTo(this.map);
    const markers = [];
    clubs.forEach(club => {
      const lat = parseFloat(club.latitude());
      const lng = parseFloat(club.longitude());
      if (isNaN(lat) || isNaN(lng)) return;
      const marker = L.marker([lat, lng]).addTo(this.map);
      let popupContent = "<div class=\"SupporterClub-map-popup\">";
      if (club.imagePath()) {
        const imageUrl = "/assets/extensions/nagusi-match-ratings/escudo/".concat(club.imagePath());
        popupContent += "<img src=\"".concat(imageUrl, "\" style=\"width: 40px; height: 40px; object-fit: contain; margin-bottom: 10px; display: block; margin-left: auto; margin-right: auto;\" /><br>");
      }
      popupContent += "<strong>".concat(club.name(), "</strong>");
      if (club.address()) popupContent += "<small>".concat(club.address(), "</small><br>");
      if (club.description()) {
        const truncatedDesc = club.description().length > 120 ? club.description().substring(0, 117) + '...' : club.description();
        popupContent += "<p style=\"font-size: 0.9em; margin: 10px 0; color: #444;\">".concat(truncatedDesc, "</p>");
      }
      popupContent += "<div class=\"SupporterClub-popup-contact\" style=\"margin-top: 10px; border-top: 1px solid #eee; pt: 10px;\">";
      if (club.email()) {
        popupContent += "<a href=\"mailto:".concat(club.email(), "\" title=\"").concat(club.email(), "\" style=\"margin: 0 5px; color: #666;\"><i class=\"fas fa-envelope\"></i></a>");
      }
      if (club.websiteUrl()) {
        popupContent += "<a href=\"".concat(club.websiteUrl(), "\" target=\"_blank\" rel=\"noopener\" style=\"margin: 0 5px; color: #666;\"><i class=\"fas fa-globe\"></i></a>");
      }
      if (club.facebookUrl()) {
        popupContent += "<a href=\"".concat(club.facebookUrl(), "\" target=\"_blank\" rel=\"noopener\" style=\"margin: 0 5px; color: #666;\"><i class=\"fab fa-facebook\"></i></a>");
      }
      if (club.instagramUrl()) {
        popupContent += "<a href=\"".concat(club.instagramUrl(), "\" target=\"_blank\" rel=\"noopener\" style=\"margin: 0 5px; color: #666;\"><i class=\"fab fa-instagram\"></i></a>");
      }
      if (club.twitterUrl()) {
        popupContent += "<a href=\"".concat(club.twitterUrl(), "\" target=\"_blank\" rel=\"noopener\" style=\"margin: 0 5px; color: #666;\"><i class=\"fab fa-twitter\"></i></a>");
      }
      popupContent += "</div>";
      popupContent += "</div>";
      marker.bindPopup(popupContent);
      markers.push(marker);
    });
    if (markers.length > 0) {
      const group = L.featureGroup(markers);
      this.map.fitBounds(group.getBounds().pad(0.1));
    }
  }
  view() {
    const allClubs = app.store.all('supporter-clubs').filter(c => c.isActive());
    const query = this.searchQuery.toLowerCase();
    const filteredClubs = allClubs.filter(c => {
      var _c$name, _c$address, _c$email, _c$description;
      if (!query) return true;
      return ((_c$name = c.name()) == null ? void 0 : _c$name.toLowerCase().includes(query)) || ((_c$address = c.address()) == null ? void 0 : _c$address.toLowerCase().includes(query)) || ((_c$email = c.email()) == null ? void 0 : _c$email.toLowerCase().includes(query)) || ((_c$description = c.description()) == null ? void 0 : _c$description.toLowerCase().includes(query));
    });
    const clubsWithGeo = allClubs.filter(c => c.latitude() && c.longitude());
    return m("div", {
      className: "SupporterClubsPage"
    }, m("div", {
      className: "athletic-full-header"
    }, m("div", {
      className: "athletic-container"
    }, m("div", {
      className: "athletic-logo"
    }, m(Link, {
      href: app.route('index')
    }, m("img", {
      src: "/assets/brand/aurrera_athletic_logo_cabecera.png",
      alt: "Foro Athletic Club - Aurrera Athletic"
    }))), m("div", {
      className: "athletic-text"
    }, m("span", {
      className: "hero-title-fallback"
    }, "AURRERA ATHLETIC"), m("p", null, SHOW_BLOOD_DONATION ? app.translator.trans('nagusi-match-ratings.forum.blood_donation.subtitle') : 'Athletic zaleen tokia'), m("div", {
      className: "header-buttons"
    }, SHOW_BLOOD_DONATION ? m(Link, {
      className: "Button support-button blood-donation-button",
      href: "/d/919-se-necesita-sangre-en-bizkaia"
    }, m("i", {
      className: "fas fa-tint",
      style: {
        color: '#e02424',
        marginRight: '8px'
      }
    }), " ", app.translator.trans('nagusi-match-ratings.forum.blood_donation.button')) : !app.session.user ? m("button", {
      className: "Button Button--primary register-button",
      onclick: () => app.modal.show(SignUpModal)
    }, m("i", {
      className: "fas fa-user-plus"
    }), " \xDAnete a la familia zurigorri") : m("a", {
      className: "Button support-button",
      href: "https://ko-fi.com/aurreraathletic",
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fas fa-coffee"
    }), " Inv\xEDtanos a un caf\xE9 zurigorri"))))), m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      title: "Directorio de Pe\xF1as"
    }), m("div", {
      className: "SupporterClubsPage-header"
    }, m("h1", null, "Directorio de pe\xF1as del Athletic Club"), m("p", {
      className: "SupporterClubsPage-disclaimer"
    }, "Directorio independiente gestionado por la comunidad de Aurrera Athletic. Los datos mostrados tienen car\xE1cter informativo y han sido recopilados de fuentes p\xFAblicas y aportaciones de usuarios.")), m("div", {
      id: "supporter-clubs-map-container",
      style: {
        marginBottom: '30px',
        display: !this.loading && clubsWithGeo.length > 0 ? 'block' : 'none'
      }
    }, m("div", {
      id: "supporter-clubs-map",
      style: {
        height: '400px',
        width: '100%',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        border: '1px solid #eee'
      }
    })), m("div", {
      className: "SupporterClubs-search-container"
    }, m("div", {
      className: "SupporterClubs-search-input"
    }, m("input", {
      className: "FormControl",
      placeholder: "Busca por nombre, localidad o provincia...",
      value: this.searchQuery,
      oninput: e => {
        this.searchQuery = e.target.value;
        m.redraw();
      }
    }), m("i", {
      className: "fas fa-search Search-icon"
    }))), m("div", {
      className: "SupporterClubs-grid"
    }, this.loading ? m("div", {
      style: {
        gridColumn: '1 / -1',
        textAlign: 'center',
        padding: '60px 0'
      }
    }, m(LoadingIndicator, null)) : filteredClubs.length > 0 ? filteredClubs.map(club => m(SupporterClubCard, {
      club: club
    })) : m("div", {
      className: "no-results"
    }, m("i", {
      className: "fas fa-search-minus"
    }), m("p", null, "No se han encontrado pe\xF1as que coincidan con tu b\xFAsqueda.")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/supporter-clubs/SupporterClubsPage', SupporterClubsPage);